import _ from "lodash";
import convert from 'convert-length';

export {
    convertInchToPixel
}

const convertInchToPixel = (inches) => {
    if (inches) {
        return convert(parseFloat(inches), 'in', 'px', {pixelsPerInch: 300});
    }

    return 0;
}
